import { apiSlice } from '../../../api/apiSlice';
import * as constants from '../../../constants';

export const CaAssignSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        createCorrectiveAction: builder.mutation({
            query: (arg: any) => ({
                url: constants.CA_ASSIGN,
                method: 'POST',
                body: arg,
            }),
            invalidatesTags: ['Corrective_action'],
        }),
        updateCorreciveAction: builder.mutation({
            query: (arg: any) => ({
                url: constants.CA_UPDATE,
                method: 'PUT',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['Corrective_action'],
        }),
        deleteCorrectiveAction: builder.mutation({
            query: (correctiveActionId: any) => ({
                url: constants.CA_DELETE,
                method: 'PUT',
                params: { correctiveActionId },
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['Corrective_action'],
        }),
        getCaEmployees: builder.query({
            query: (arg: any) => {
                const { employeeNumber } = arg;
                return {
                    url: constants.CA_EMPLOYEES,
                    params: { employeeNumber },
                };
            },
            providesTags: ['Corrective_action'],
        }),
        getSubCategories: builder.query({
            query: (arg: any) => {
                const params = new URLSearchParams();
                if (arg.categoryId && arg.categoryId.length > 0) {
                    arg.categoryId.forEach((id: any) => params.append('categoryId', id));
                }
                return `${constants.CA_SUB_CATEGORIES}?${params.toString()}`;
            },
            providesTags: ['Corrective_action'],
        }),
        getCaNotice: builder.query({
            query: (arg: any) => {
                const { categoryID, severityLevelID, empLanguageID, countryID, empRoleId } = arg;
                return {
                    url: constants.CA_NOTICE_ASSIGNMENT,
                    params: { categoryID, severityLevelID, empLanguageID, countryID, empRoleId },
                };
            },
            providesTags: ['Corrective_action'],
        }),
        getCorrectiveAction: builder.query({
            query: (arg: any) => {
                const { correctiveActionId } = arg;
                return {
                    url: constants.CA_VIEW,
                    params: { correctiveActionId },
                };
            },
            providesTags: ['Corrective_action'],
        }),
        getCaDocuments: builder.query({
            query: (arg: any) => {
                const { correctiveActionId } = arg;
                return {
                    url: constants.CA_CA_DOCUMENTS,
                    params: { correctiveActionId },
                };
            },
            providesTags: ['Corrective_action'],
        }),
        getCaApproverDetails: builder.query({
            query: (arg: any) => {
                const { templateId, severityLevelId } = arg;
                return {
                    url: constants.CA_APPROVER_DETAILS,
                    params: { templateId, severityLevelId },
                };
            },
            providesTags: ['Corrective_action'],
        }),
        getCaManagerTlSearch: builder.query({
            query: (arg: any) => {
                const { employeeNumber, isCurrentTeam, isApprovals, CreationStartDate, CreationEndDate } =
                    arg;
                return {
                    url: constants.CA_SEARCH,
                    params: {
                        employeeNumber,
                        isCurrentTeam,
                        isApprovals,
                        CreationStartDate,
                        CreationEndDate,
                    },
                };
            },
            providesTags: ['Corrective_action'],
        }),
        deleteCaDocument: builder.mutation({
            query: (payload: { ca_document_id: string; ca_document_name: string }) => ({
                url: constants.DELETE_CA_DOCUMENT,
                method: 'DELETE',
                body: payload, // BODY — because API expects FromBody
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['Corrective_action'],
        }),
        getMisConduct: builder.query({
            query: (arg: any) => {
                const params = new URLSearchParams();
                // if(arg.countryId){params.append('countryId', arg.countryId);}
                // if(arg.categoryId && arg.categoryId.length > 0 ){arg.categoryId.forEach((id: any) => params.append('categoryId', id));}
                // return `${constants.CA_MISCONDUCT}?${params.toString()}`;
                if (arg?.countryId) {
                    params.append('countryId', arg.countryId);
                }

                if(arg.categoryId && arg.categoryId.length > 0 ){arg.categoryId.forEach((id: any) => params.append('categoryId', id));}

                return `${constants.CA_MISCONDUCT}?${params.toString()}`;
            },
            providesTags: ['Corrective_action'],
        }),
    }),
});

export const {
    useGetCaApproverDetailsQuery,
    useGetCaEmployeesQuery,
    useGetSubCategoriesQuery,
    useGetCaNoticeQuery,
    useGetCorrectiveActionQuery,
    useGetCaDocumentsQuery,
    useCreateCorrectiveActionMutation,
    useUpdateCorreciveActionMutation,
    useDeleteCorrectiveActionMutation,
    useGetCaManagerTlSearchQuery,
    useDeleteCaDocumentMutation,
    useGetMisConductQuery,
} = CaAssignSlice;
